import { render } from "./ShowOrder.vue?vue&type=template&id=6038df34&scoped=true"
import script from "./ShowOrder.vue?vue&type=script&lang=js"
export * from "./ShowOrder.vue?vue&type=script&lang=js"

import "./ShowOrder.vue?vue&type=style&index=0&id=6038df34&scoped=true&lang=css"

import exportComponent from "/Users/renzocappelli/Lavoro/bikinilovers/newPosBKL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6038df34"]])

export default __exports__